import o from'@mui/material/Box';var e=o;export{e as Box};//# sourceMappingURL=index.mjs.map
//# sourceMappingURL=index.mjs.map